/* sgb-sample-offer.js
   Vanilla 4-screen sample/gift popup. Brand config via window.SGB_SAMPLE_OFFER.
   Email step IS #sgb-shopify-customer (user types first name + email,
   Keep Going is type=submit). Pal step IS #sgb-shopify-friend. One user-gesture
   submit each. Do not requestSubmit / form.submit / Shopify.captcha.protect —
   that escalates to a visible hCaptcha challenge. Customer create is
   fetch POST popupCustomerUrl /api/popup-customer (Admin API via mailer).
   preventDefault the native /contact POST — storefront hCaptcha blocks it.
   liveCart: add $4.99 Single Can + GET /discount/ONME (pal) or /discount/HLSAMPLE (buyer).
   Does NOT call Klaviyo. Does NOT call /api/sample-friend/send (Flow emails
   the pal when tagged sgb-onme-friend + SUBSCRIBED). SMS does not send.
   H&L / pair: quiz.steps (Q1 then Q2) then email → reveal (can + pal).
   No SMS on the live H&L path. Orchard non-pair can still show SMS.
*/
(function () {
  'use strict';

  var SEEN_KEY = 'sgb_sample_offer_v2';
  var ROOT_ID = 'sgb-sample-offer';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function qs(name) {
    try { return new URLSearchParams(window.location.search).get(name); }
    catch (e) { return null; }
  }

  function emit(name, detail) {
    var payload = detail || {};
    try { window.dispatchEvent(new CustomEvent(name, { detail: payload })); } catch (e) {}
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
    } catch (e2) {}
    if (window.SGB_SAMPLE_DEBUG) {
      try { console.log('[sgb]', name, payload); } catch (e3) {}
    }
  }

  function storageGet(store, key) {
    try { return store.getItem(key); } catch (e) { return null; }
  }
  function storageSet(store, key, val) {
    try { store.setItem(key, val); } catch (e) {}
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());
  }
  function validPhone(v) {
    var d = String(v || '').replace(/\D/g, '');
    return d.length >= 10 && d.length <= 15;
  }

  function slugTag(v) {
    return String(v || '').toLowerCase().replace(/[^a-z0-9._-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
  }

  function isPairOffer(cfg) {
    return !!(cfg && cfg.quiz && cfg.quiz.steps && cfg.quiz.steps.length) ||
      !!(cfg && cfg.sample && cfg.sample.picker === 'two_cards');
  }


  function popupCustomerUrl(cfg) {
    var raw = String((cfg && cfg.popupCustomerUrl) || window.SGB_POPUP_CUSTOMER || '').trim();
    if (!raw) raw = 'https://sample-friend-mailer-production.up.railway.app';
    if (/\/api\/popup-customer\/?$/.test(raw)) return raw;
    return raw.replace(/\/$/, '') + '/api/popup-customer';
  }

  function createPopupCustomer(cfg, payload) {
    return fetch(popupCustomerUrl(cfg), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || !j || !j.ok) {
          var err = new Error((j && j.error) || ('popup_customer_' + r.status));
          err.status = r.status;
          throw err;
        }
        return j;
      }, function () {
        throw new Error('popup_customer_' + r.status);
      });
    });
  }

  function tagsFromState(state) {
    var tags = ['newsletter', 'sgb-popup'];
    if (state.brand) tags.push('sgb-' + slugTag(state.brand));
    if (state.friend) tags.push('sgb-friend-landing');
    if (state.answer) tags.push('quiz-' + slugTag(state.answer));
    if (state.answer2) tags.push('quiz2-' + slugTag(state.answer2));
    if (state.offer) tags.push('offer-' + slugTag(state.offer));
    if (state.keepOrGift) tags.push('keep-' + slugTag(state.keepOrGift));
    if (state.selfSku && state.giftSku) tags.push('sample-pair');
    else if (state.sampleMode) tags.push('sample-' + slugTag(state.sampleMode));
    if (state.selfSku) tags.push('sku-' + slugTag(state.selfSku));
    else if (state.sampleSku) tags.push('sku-' + slugTag(state.sampleSku));
    if (state.giftSku) tags.push('sku-gift-' + slugTag(state.giftSku));
    if (state.phone) tags.push('sms-optin');
    return tags;
  }


  /* Park field hosts back in #sgb-shopify-wrap BEFORE any screens.innerHTML
     replace. Never requestSubmit, form.submit(), or Shopify.captcha.protect.
     Customer create is fetch POST /api/popup-customer, not /contact. */
  function parkShopifyForms() {
    var wrap = document.getElementById('sgb-shopify-wrap');
    if (!wrap) return;
    var customer = document.getElementById('sgb-shopify-customer');
    var friendForm = document.getElementById('sgb-shopify-friend');
    if (customer && customer.parentNode !== wrap) wrap.appendChild(customer);
    if (friendForm && friendForm.parentNode !== wrap) wrap.appendChild(friendForm);
  }

  function waitForFrame(id, ms) {
    return new Promise(function (resolve) {
      var frame = document.getElementById(id);
      var settled = false;
      function done() {
        if (settled) return;
        settled = true;
        if (frame) frame.removeEventListener('load', done);
        resolve();
      }
      if (frame) frame.addEventListener('load', done);
      setTimeout(done, ms || 2000);
    });
  }

  function waitForCustomerFrame(ms) {
    return waitForFrame('sgb-shopify-frame', ms);
  }

  function waitForFriendFrame(ms) {
    return waitForFrame('sgb-shopify-friend-frame', ms);
  }


  function waitForAgeGate(cfg, cb) {
    var selectors = (cfg.ageGate && cfg.ageGate.selectors) || [];
    var key = cfg.ageGate && cfg.ageGate.storageKey;
    var val = (cfg.ageGate && cfg.ageGate.storageValue) || '1';

    function gateUp() {
      /* H&L #age-gate is rendered hidden and un-hidden after boot: treat it as up until the visitor has passed (hl-verified / hl_age_ok). */
      if (document.getElementById('age-gate') && !alreadyOk()) return true;
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (!el) continue;
        if (el.hasAttribute('hidden')) continue;
        if (el.classList && el.classList.contains('oe-ag-out')) continue;
        return true;
      }
      return false;
    }

    function alreadyOk() {
      /* Locked age key: ageGate.storageKey (hl_age_ok). Legacy reads migrate. */
      var legacy = ['hl-verified', 'hl-cart-age-ok'];
      if (key && storageGet(window.localStorage, key) === val) return true;
      for (var i = 0; i < legacy.length; i++) {
        if (storageGet(window.localStorage, legacy[i]) === '1') {
          if (key) storageSet(window.localStorage, key, val);
          return true;
        }
      }
      return false;
    }

    if (!gateUp()) { cb(); return; }

    var started = Date.now();
    var iv = setInterval(function () {
      if (!gateUp() || alreadyOk()) {
        clearInterval(iv);
        cb();
      } else if (Date.now() - started > 180000) {
        clearInterval(iv);
        /* do not force-open over a live age gate */
      }
    }, 250);
  }

  function shouldSkip(cfg, root) {
    if (qs('sgb_debug') === '1' || qs('sgb_preview') === '1') return false;
    if (root.getAttribute('data-subscribed') === 'true') return true;
    if (storageGet(window.localStorage, SEEN_KEY) === '1') return true;
    return false;
  }

  function markSeen() {
    storageSet(window.localStorage, SEEN_KEY, '1');
  }

  function hideLegacyPopup(root) {
    if (root.getAttribute('data-replace-legacy') !== 'true') return;
    var legacy = document.getElementById('oe-popup');
    if (legacy) {
      legacy.setAttribute('hidden', '');
      legacy.style.display = 'none';
    }
  }

  function sampleFlavors(sample) {
    return ((sample && sample.flavors) || []).filter(function (f) {
      return f && f.id !== 'lous-pick';
    });
  }

  function build(root, cfg) {
    var copy = cfg.copy || {};
    var friend = qs('sgb_friend') === '1' || root.getAttribute('data-friend') === 'true';
    var brand = cfg.brand || 'herbandlous';
    var pair = isPairOffer(cfg);
    var state = {
      brand: brand,
      friend: friend,
      quizStep: 0,
      answer: null,
      answer2: null,
      suggestedSku: null,
      email: '',
      firstName: '',
      phone: '',
      offer: null,
      keepOrGift: null,
      sampleMode: null,
      sampleSku: null,
      selfSku: null,
      giftSku: null,
      giftEmail: ''
    };

    root.setAttribute('data-sgb-brand', brand);
    root.innerHTML = '' +
      '<div class="sgb-overlay" data-sgb-close></div>' +
      '<div class="sgb-card" role="dialog" aria-modal="true" aria-labelledby="sgb-title">' +
        '<button type="button" class="sgb-x" data-sgb-close aria-label="' + esc(copy.closeLabel || 'Close') + '">&times;</button>' +
        '<div class="sgb-progress" aria-hidden="true">' +
          '<i data-dot="quiz"></i><i data-dot="email"></i>' +
          ((pair || brand === 'herbandlous') ? '' : '<i data-dot="sms"></i>') +
          '<i data-dot="reveal"></i>' +
        '</div>' +
        '<div class="sgb-screens"></div>' +
      '</div>';

    var screens = $('.sgb-screens', root);
    var lastFocus = document.activeElement;

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function setDots(name) {
      $$('[data-dot]', root).forEach(function (d) {
        d.classList.toggle('on', d.getAttribute('data-dot') === name);
      });
    }

    function close() {
      root.classList.remove('sgb-open');
      root.setAttribute('hidden', '');
      emit('sgb:close', { brand: brand });
      markSeen();
      try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {}
    }

    function open() {
      hideLegacyPopup(root);
      root.removeAttribute('hidden');
      root.classList.add('sgb-open');
      emit('sgb:open', { brand: brand, friend: friend });
      if (friend) emit('sgb:friend-landing', { brand: brand });
      var hasQuiz = (cfg.quiz && ((cfg.quiz.steps && cfg.quiz.steps.length) || (cfg.quiz.options && cfg.quiz.options.length)));
      show(hasQuiz ? 'quiz' : 'email');
      var card = $('.sgb-card', root);
      if (card) card.focus();
    }

    root.addEventListener('click', function (e) {
      var hit = e.target.closest('[data-sgb-close]');
      if (!hit || !root.contains(hit)) return;
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('sgb-open')) close();
    });

    function show(name) {
      setDots(name === 'done' ? 'reveal' : name);
      parkShopifyForms();
      screens.innerHTML = render(name);
      bind(name);
    }

    function eyebrow() {
      if (friend) return copy.friendEyebrow || copy.eyebrow || '';
      return copy.eyebrow || '';
    }

    function render(name) {
      if (name === 'quiz') return renderQuiz();
      if (name === 'email') return renderEmail();
      if (name === 'sms') return renderSms();
      if (name === 'reveal') return renderReveal();
      if (name === 'done') return renderDone();
      return '';
    }

    function currentQuizStep() {
      var steps = cfg.quiz && cfg.quiz.steps;
      if (!steps || !steps.length) return null;
      var i = state.quizStep || 0;
      if (i < 0) i = 0;
      if (i >= steps.length) i = steps.length - 1;
      return { index: i, step: steps[i], total: steps.length };
    }

    function renderQuiz() {
      var stepped = currentQuizStep();
      var title, sub, opts;
      if (stepped) {
        title = stepped.step.question || (stepped.index === 0
          ? (friend ? (copy.friendQuizTitle || copy.quizTitle) : copy.quizTitle)
          : (copy.quizTitle2 || ''));
        sub = stepped.index === 0
          ? (friend ? (copy.friendQuizSub || copy.quizSub) : (copy.quizSub || ''))
          : '';
        opts = stepped.step.options || [];
      } else {
        title = friend ? (copy.friendQuizTitle || copy.quizTitle) : copy.quizTitle;
        sub = friend ? (copy.friendQuizSub || copy.quizSub) : copy.quizSub;
        opts = (cfg.quiz && cfg.quiz.options) || [];
      }
      var buttons = opts.map(function (o) {
        return '<button type="button" class="sgb-chip" data-answer="' + esc(o.id) + '">' + esc(o.label) + '</button>';
      }).join('');
      return (
        '<p class="sgb-ey">' + esc(eyebrow()) + '</p>' +
        '<h2 id="sgb-title">' + esc(title) + '</h2>' +
        (sub ? '<p class="sgb-sub">' + esc(sub) + '</p>' : '') +
        '<div class="sgb-chips">' + buttons + '</div>' +
        '<p class="sgb-fine">' + esc(copy.fine || '') + '</p>'
      );
    }

    function renderEmail() {
      var title = friend ? (copy.friendEmailTitle || copy.emailTitle) : copy.emailTitle;
      var sub = friend ? (copy.friendEmailSub || copy.emailSub) : copy.emailSub;
      return (
        '<p class="sgb-ey">' + esc(copy.emailEyebrow || eyebrow()) + '</p>' +
        '<h2 id="sgb-title">' + esc(title) + '</h2>' +
        '<p class="sgb-sub">' + esc(sub) + '</p>' +
        '<div data-sgb-email-slot></div>' +
        '<p class="sgb-fine">' + esc(copy.fine || '') + '</p>'
      );
    }

    function renderSms() {
      return (
        '<p class="sgb-ey">' + esc(copy.smsEyebrow || '') + '</p>' +
        '<h2 id="sgb-title">' + esc(copy.smsTitle || '') + '</h2>' +
        '<p class="sgb-sub">' + esc(copy.smsSub || '') + '</p>' +
        '<form class="sgb-form" data-sgb-sms-form novalidate>' +
          '<label class="sgb-sr" for="sgb-phone">Mobile number</label>' +
          '<div class="sgb-row">' +
            '<input id="sgb-phone" type="tel" autocomplete="tel" required placeholder="' + esc(copy.smsPlaceholder || '') + '">' +
            '<button type="submit" class="sgb-btn">' + esc(copy.smsCta || 'Text me') + '</button>' +
          '</div>' +
          '<label class="sgb-check"><input type="checkbox" id="sgb-sms-21" required> <span>I confirm I\'m 21 or older</span></label>' +
          '<p class="sgb-err" data-err hidden></p>' +
        '</form>' +
        '<button type="button" class="sgb-textbtn" data-sgb-skip-sms>' + esc(copy.smsSkip || 'Skip') + '</button>' +
        '<p class="sgb-fine">' + esc(copy.smsLegal || copy.fine || '') + '</p>'
      );
    }

    function flavorButtons(mode, selectedSku) {
      return sampleFlavors(cfg.sample).map(function (f) {
        var sku = f.sku || f.id;
        var on = selectedSku && selectedSku === sku;
        return '<button type="button" class="sgb-flavor' + (on ? ' on' : '') + '" data-sku="' + esc(sku) + '" data-mode="' + esc(mode) + '" data-handle="' + esc(f.handle || '') + '"' +
          (on ? ' style="outline:2px solid currentColor;outline-offset:2px;"' : '') + '>' +
          (f.image ? '<img src="' + esc(f.image) + '" alt="">' : '') +
          '<span>' + esc(f.label) + '</span></button>';
      }).join('');
    }

    function renderPairPicker() {
      var sample = cfg.sample || {};
      var sc = sample.copy || {};
      return (
        '<div class="sgb-pair">' +
          '<div class="sgb-pair-col" data-pair="self">' +
            '<p class="sgb-lead">' + esc(sc.selfTitle || 'Your can') + '</p>' +
            '<p class="sgb-sub sgb-sub-tight">' + esc(sc.selfSub || '') + '</p>' +
            '<div class="sgb-flavorgrid">' + flavorButtons('self', state.selfSku) + '</div>' +
          '</div>' +
          '<div class="sgb-pair-col" data-pair="gift">' +
            '<p class="sgb-lead">' + esc(sc.giftTitle || 'Your pal') + '</p>' +
            '<p class="sgb-sub sgb-sub-tight">' + esc(sc.giftSub || "Lou emails them a free drink. They're not on the list.") + '</p>' +
            '<div class="sgb-giftmail" data-sgb-friend-slot></div>' +
          '</div>' +
        '</div>' +
        '<p class="sgb-err" data-pair-err hidden></p>' +
        '<div data-sgb-pair-submit-slot></div>'
      );
    }

    function renderFriendPicker() {
      var sample = cfg.sample || {};
      var sc = sample.copy || {};
      var canGo = !!state.selfSku;
      return (
        '<p class="sgb-lead">' + esc(sc.friendTitle || 'Your can') + '</p>' +
        '<p class="sgb-sub sgb-sub-tight">' + esc(sc.friendSub || "Pick one. It's free. You cover $4.90 ship.") + '</p>' +
        '<div class="sgb-flavorgrid">' + flavorButtons('self', state.selfSku) + '</div>' +
        '<p class="sgb-err" data-pair-err hidden></p>' +
        '<button type="button" class="sgb-btn sgb-btn-block" data-sgb-friend-done' +
          (canGo ? '' : ' disabled') + '>' +
          esc(copy.friendCta || 'Claim my can') +
        '</button>'
      );
    }

    function renderReveal() {
      if (friend) {
        var ft = copy.friendRevealTitle || (cfg.offer && cfg.offer.friend && cfg.offer.friend.headline) || 'Someone bought you a drink.';
        var fs = copy.friendRevealSub || (cfg.offer && cfg.offer.friend && cfg.offer.friend.sub) || "Pick one can. It's free. You cover $4.90 ship.";
        return (
          '<p class="sgb-ey">' + esc(eyebrow()) + '</p>' +
          '<h2 id="sgb-title">' + esc(ft) + '</h2>' +
          '<p class="sgb-sub">' + esc(fs) + '</p>' +
          renderFriendPicker() +
          '<p class="sgb-fine">' + esc(copy.fine || '') + '</p>'
        );
      }
      if (pair || state.offer === 'sample-pair') {
        var title = copy.reveal15Title || (cfg.offer && cfg.offer.smsUnlock && cfg.offer.smsUnlock.headline) || '';
        var sub = copy.reveal15Sub || (cfg.offer && cfg.offer.smsUnlock && cfg.offer.smsUnlock.sub) || '';
        return (
          '<p class="sgb-ey">' + esc(eyebrow()) + '</p>' +
          '<h2 id="sgb-title">' + esc(title) + '</h2>' +
          '<p class="sgb-sub">' + esc(sub) + '</p>' +
          renderPairPicker() +
          '<p class="sgb-fine">' + esc(copy.fine || '') + '</p>'
        );
      }

      if (state.offer === '10off') {
        var e = cfg.offer && cfg.offer.emailOnly || {};
        return (
          '<p class="sgb-ey">' + esc(eyebrow()) + '</p>' +
          '<h2 id="sgb-title">' + esc(e.headline || copy.emailTitle) + '</h2>' +
          '<p class="sgb-sub">' + esc(e.sub || '') + '</p>' +
          '<p class="sgb-code" data-code>' + esc(e.discountCode || 'TODO_DIGITAL') + '</p>' +
          '<p class="sgb-fine">Code is a placeholder. Digital has not created the live 10% code. Nothing was applied.</p>' +
          '<button type="button" class="sgb-btn sgb-btn-block" data-sgb-close>Got it</button>'
        );
      }

      var s = cfg.offer && cfg.offer.smsUnlock || {};
      var keepGift =
        '<div class="sgb-split">' +
          '<button type="button" class="sgb-cardbtn" data-keep="keep"><b>' + esc(copy.keepCta || 'Keep it') + '</b></button>' +
          '<button type="button" class="sgb-cardbtn" data-keep="gift"><b>' + esc(copy.giftCta || 'Gift it') + '</b></button>' +
        '</div>' +
        '<form class="sgb-giftmail" data-sgb-giftmail hidden>' +
          '<input type="email" placeholder="' + esc(copy.giftEmailPlaceholder || "friend's email") + '" autocomplete="off">' +
          '<button type="submit" class="sgb-btn">Send the code</button>' +
        '</form>';

      return (
        '<p class="sgb-ey">' + esc(eyebrow()) + '</p>' +
        '<h2 id="sgb-title">' + esc(s.headline || copy.reveal15Title) + '</h2>' +
        '<p class="sgb-sub">' + esc(s.sub || copy.reveal15Sub) + '</p>' +
        keepGift +
        '<div class="sgb-rule"></div>' +
        '<p class="sgb-lead">' + esc(copy.sampleLead || '') + '</p>' +
        renderPicker() +
        '<p class="sgb-fine">' + esc(copy.fine || '') + '</p>'
      );
    }

    function renderPicker() {
      var sample = cfg.sample || {};
      if (sample.picker === 'two_cards') {
        return renderPairPicker();
      }

      var products = (sample.products || []).map(function (p) {
        return '<button type="button" class="sgb-prod" data-sku="' + esc(p.sku || p.id) + '" data-handle="' + esc(p.handle || '') + '" data-mode="gift">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') +
          '<span class="t1">' + esc(p.label) + '</span>' +
          '<span class="t2">' + esc(p.kind || '') + (p.priceNote ? ' · ' + esc(p.priceNote) : '') + '</span>' +
        '</button>';
      }).join('');
      return (
        '<p class="sgb-lead">' + esc(sample.copy && sample.copy.gridTitle || '') + '</p>' +
        '<p class="sgb-sub sgb-sub-tight">' + esc(sample.copy && sample.copy.gridSub || '') + '</p>' +
        '<div class="sgb-grid">' + products + '</div>'
      );
    }

    function renderDone() {
      var sub = state.cartFailed
        ? (copy.doneFailSub || "Couldn't add the sample to your cart. Close and try again.")
        : (friend ? (copy.friendDoneSub || copy.doneSub || '') : (copy.doneSub || ''));
      return (
        '<p class="sgb-ey">' + esc(eyebrow()) + '</p>' +
        '<h2 id="sgb-title">' + esc(copy.doneTitle || "You're in.") + '</h2>' +
        '<p class="sgb-sub">' + esc(sub) + '</p>' +
        '<button type="button" class="sgb-btn sgb-btn-block" data-sgb-close>Close</button>'
      );
    }

    function optionById(opts, id) {
      for (var i = 0; i < (opts || []).length; i++) {
        if (opts[i] && opts[i].id === id) return opts[i];
      }
      return null;
    }

    function markFlavor(mode, btn) {
      $$('[data-sku][data-mode="' + mode + '"]', root).forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('on', on);
        b.style.outline = on ? '2px solid currentColor' : '';
        b.style.outlineOffset = on ? '2px' : '';
      });
    }

    function updatePairDone() {
      var btn = document.getElementById('sgb-shopify-friend-submit') || $('[data-sgb-pair-done]', root);
      var em = document.getElementById('sgb-shopify-friend-email');
      if (em) {
        var v = em.value.trim();
        state.giftEmail = validEmail(v) ? v : '';
      }
      if (btn) btn.disabled = !(state.selfSku && validEmail(state.giftEmail));
    }

    function mountCustomerForm() {
      var slot = $('[data-sgb-email-slot]', root);
      var form = document.getElementById('sgb-shopify-customer');
      if (!slot || !form) return;
      form.setAttribute('target', 'sgb-shopify-frame');
      form.classList.add('sgb-form');
      form.setAttribute('novalidate', '');
      var first = document.getElementById('sgb-shopify-first');
      var email = document.getElementById('sgb-shopify-email');
      var phone = document.getElementById('sgb-shopify-phone');
      var submit = document.getElementById('sgb-shopify-submit');
      if (first) {
        try { first.type = 'text'; } catch (e1) {}
        first.setAttribute('autocomplete', 'given-name');
        first.setAttribute('required', '');
        first.placeholder = copy.namePlaceholder || 'Your first name';
        if (state.firstName) first.value = state.firstName;
      }
      if (email) {
        try { email.type = 'email'; } catch (e2) {}
        email.setAttribute('autocomplete', 'email');
        email.setAttribute('required', '');
        email.placeholder = copy.emailPlaceholder || 'you@email.com';
        if (state.email) email.value = state.email;
      }
      if (phone) {
        try { phone.type = 'hidden'; } catch (e3) {}
      }
      if (submit) submit.textContent = copy.emailCta || 'Keep going';
      slot.appendChild(form);
      if (!form._sgbBound) {
        form._sgbBound = true;
        form.addEventListener('submit', onCustomerSubmit);
      }
    }

    function onCustomerSubmit(e) {
      e.preventDefault();
      var form = e.currentTarget;
      var first = document.getElementById('sgb-shopify-first');
      var email = document.getElementById('sgb-shopify-email');
      var err = form.querySelector('[data-err]');
      var name = first && first.value ? first.value.trim() : '';
      var em = email && email.value ? email.value.trim() : '';
      if (name.length < 2) {
        if (err) { err.hidden = false; err.textContent = 'Need a first name.'; }
        return;
      }
      if (!validEmail(em)) {
        if (err) { err.hidden = false; err.textContent = 'Need a real email.'; }
        return;
      }
      state.firstName = name;
      state.email = em;
      var tags = tagsFromState(state);
      emit('sgb:email', { brand: brand, email: state.email, firstName: state.firstName });
      emit('sgb:shopify-customer', { brand: brand, email: em, tags: tags, native: false, api: 'popup-customer' });
      var next = (pair || brand === 'herbandlous') ? 'reveal' : 'sms';
      var submitBtn = document.getElementById('sgb-shopify-submit');
      if (submitBtn) submitBtn.disabled = true;
      if (err) err.hidden = true;
      createPopupCustomer(cfg, {
        role: 'buyer',
        email: em,
        firstName: name,
        tags: tags
      }).then(function (res) {
        emit('sgb:popup-customer', { brand: brand, role: 'buyer', id: res.id, created: res.created });
        if (next === 'reveal') {
          state.offer = 'sample-pair';
          emit('sgb:offer-reveal', { brand: brand, offer: state.offer });
          markSeen();
        }
        show(next);
      }).catch(function (ex) {
        if (submitBtn) submitBtn.disabled = false;
        if (err) {
          err.hidden = false;
          err.textContent = "Couldn't save that email. Try again.";
        }
        emit('sgb:popup-customer-error', { brand: brand, role: 'buyer', error: String(ex && ex.message || ex) });
      });
    }

    function mountFriendForm() {
      var slot = $('[data-sgb-friend-slot]', root);
      var form = document.getElementById('sgb-shopify-friend');
      if (!slot || !form) return;
      form.setAttribute('target', 'sgb-shopify-friend-frame');
      form.classList.add('sgb-form');
      form.setAttribute('novalidate', '');
      var email = document.getElementById('sgb-shopify-friend-email');
      var submit = document.getElementById('sgb-shopify-friend-submit');
      if (email) {
        try { email.type = 'email'; } catch (e4) {}
        email.setAttribute('autocomplete', 'off');
        email.placeholder = copy.giftEmailPlaceholder || "friend's email";
        if (state.giftEmail) email.value = state.giftEmail;
      }
      if (submit) submit.textContent = copy.emailCta || 'Keep going';
      slot.appendChild(form);
      var dest = $('[data-sgb-pair-submit-slot]', root);
      if (submit && dest) {
        submit.setAttribute('form', 'sgb-shopify-friend');
        dest.appendChild(submit);
      }
      if (email && !email._sgbPairBound) {
        email._sgbPairBound = true;
        email.addEventListener('input', updatePairDone);
        email.addEventListener('change', updatePairDone);
      }
      if (!form._sgbBound) {
        form._sgbBound = true;
        form.addEventListener('submit', onFriendSubmit);
      }
      updatePairDone();
    }

    function onFriendSubmit(e) {
      e.preventDefault();
      var emailEl = document.getElementById('sgb-shopify-friend-email');
      var email = emailEl && emailEl.value ? emailEl.value.trim() : '';
      var err = $('[data-pair-err]', root);
      if (!state.selfSku || !validEmail(email)) {
        if (err) {
          err.hidden = false;
          err.textContent = "Pick your can and your pal's email.";
        }
        return;
      }
      state.giftEmail = email;
      state.sampleMode = 'self';
      state.offer = 'sample-pair';
      var sender = state.firstName || 'A friend';
      var tags = ['sgb-onme-friend', 'from-' + slugTag(sender)];
      emit('sgb:sample-choice', {
        brand: brand,
        sku: state.selfSku,
        mode: 'self',
        friendEmail: state.giftEmail
      });
      emit('sgb:shopify-friend', { brand: brand, email: email, tags: tags, native: false, api: 'popup-customer' });
      var doneBtn = document.getElementById('sgb-shopify-friend-submit') || (e.submitter || null);
      if (doneBtn) doneBtn.disabled = true;
      if (err) err.hidden = true;
      createPopupCustomer(cfg, {
        role: 'pal',
        email: email,
        tags: tags
      }).then(function (res) {
        emit('sgb:popup-customer', { brand: brand, role: 'pal', id: res.id, created: res.created });
        if (!cfg.liveCart) {
          show('done');
          return;
        }
        return maybeCart().then(function (ok) {
          if (!ok) {
            state.cartFailed = true;
            show('done');
          }
        });
      }).catch(function (ex) {
        if (doneBtn) doneBtn.disabled = false;
        if (err) {
          err.hidden = false;
          err.textContent = "Couldn't save your pal. Try again.";
        }
        emit('sgb:popup-customer-error', { brand: brand, role: 'pal', error: String(ex && ex.message || ex) });
      });
    }

    function bind(name) {
      if (name === 'quiz') {
        $$('[data-answer]', root).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var id = btn.getAttribute('data-answer');
            var stepped = currentQuizStep();
            if (stepped) {
              var opt = optionById(stepped.step.options, id);
              if (stepped.index === 0) {
                state.answer = id;
                if (opt && opt.mapsTo) state.suggestedSku = opt.mapsTo;
                emit('sgb:quiz-answer', { brand: brand, answer: state.answer, step: stepped.step.id || 'q1' });
                if (stepped.total > 1) {
                  state.quizStep = 1;
                  show('quiz');
                  return;
                }
              } else {
                state.answer2 = id;
                emit('sgb:quiz-answer', { brand: brand, answer: state.answer2, step: stepped.step.id || 'q2', stepIndex: stepped.index });
              }
              show('email');
              return;
            }
            state.answer = id;
            emit('sgb:quiz-answer', { brand: brand, answer: state.answer });
            show('email');
          });
        });
      }

      if (name === 'email') {
        mountCustomerForm();
      }

      if (name === 'sms') {
        var sform = $('[data-sgb-sms-form]', root);
        sform.addEventListener('submit', function (e) {
          e.preventDefault();
          var input = $('#sgb-phone', root);
          var box = $('#sgb-sms-21', root);
          var err = $('[data-err]', sform);
          if (!box.checked) {
            err.hidden = false;
            err.textContent = 'Confirm you\'re 21+.';
            return;
          }
          if (!validPhone(input.value)) {
            err.hidden = false;
            err.textContent = 'Need a real mobile number.';
            return;
          }
          state.phone = input.value.trim();
          state.offer = pair ? 'sample-pair' : ((cfg.offer && cfg.offer.smsUnlock && cfg.offer.smsUnlock.type) || '15off50');
          emit('sgb:sms-complete', { brand: brand, phone: state.phone });
          emit('sgb:offer-reveal', { brand: brand, offer: state.offer });
          markSeen();
          show('reveal');
        });
        var skip = $('[data-sgb-skip-sms]', root);
        if (skip) skip.addEventListener('click', function () {
          /* H&L skip still gets the two free cans. Orchard keeps the 10% path.
             Do not re-POST the buyer form — one user-gesture submit is enough. */
          state.offer = pair ? 'sample-pair' : '10off';
          emit('sgb:offer-reveal', { brand: brand, offer: state.offer });
          markSeen();
          show('reveal');
        });
      }

      if (name === 'reveal') {
        if (friend) {
          $$('[data-sku]', root).forEach(function (btn) {
            btn.addEventListener('click', function () {
              var sku = btn.getAttribute('data-sku');
              state.selfSku = sku;
              state.sampleSku = sku;
              state.sampleMode = 'self';
              markFlavor('self', btn);
              emit('sgb:sample-choice', { brand: brand, sku: sku, mode: 'friend' });
              var fbtn = $('[data-sgb-friend-done]', root);
              if (fbtn) fbtn.disabled = !state.selfSku;
            });
          });
          var friendDone = $('[data-sgb-friend-done]', root);
          if (friendDone) {
            friendDone.addEventListener('click', function () {
              var err = $('[data-pair-err]', root);
              if (!state.selfSku) {
                if (err) {
                  err.hidden = false;
                  err.textContent = 'Pick your can.';
                }
                return;
              }
              emit('sgb:sample-choice', { brand: brand, sku: state.selfSku, mode: 'friend' });
              if (!cfg.liveCart) {
                show('done');
                return;
              }
              friendDone.disabled = true;
              maybeCart().then(function (ok) {
                if (!ok) {
                  state.cartFailed = true;
                  show('done');
                }
              });
            });
          }
          return;
        }
        if (pair || state.offer === 'sample-pair') {
          $$('[data-sku]', root).forEach(function (btn) {
            btn.addEventListener('click', function () {
              var mode = btn.getAttribute('data-mode') || 'self';
              var sku = btn.getAttribute('data-sku');
              if (mode === 'gift') {
                state.giftSku = sku;
              } else {
                state.selfSku = sku;
                state.sampleSku = sku;
              }
              markFlavor(mode, btn);
              emit('sgb:sample-choice', { brand: brand, sku: sku, mode: mode });
              updatePairDone();
            });
          });
          mountFriendForm();
          return;
        }

        $$('[data-keep]', root).forEach(function (btn) {
          btn.addEventListener('click', function () {
            state.keepOrGift = btn.getAttribute('data-keep');
            emit('sgb:keep-or-gift', { brand: brand, choice: state.keepOrGift });
            $$('[data-keep]', root).forEach(function (b) {
              b.classList.toggle('on', b === btn);
            });
            var gform = $('[data-sgb-giftmail]', root);
            if (gform) gform.hidden = state.keepOrGift !== 'gift';
          });
        });
        var gform = $('[data-sgb-giftmail]', root);
        if (gform) {
          gform.addEventListener('submit', function (e) {
            e.preventDefault();
            var em = $('input', gform);
            if (!validEmail(em.value)) return;
            state.giftEmail = em.value.trim();
            emit('sgb:keep-or-gift', { brand: brand, choice: 'gift', friendEmail: state.giftEmail });
            gform.querySelector('button').textContent = 'Saved — not sent';
          });
        }
        $$('[data-mode]', root).forEach(function (btn) {
          if (btn.classList.contains('sgb-prod')) return;
          btn.addEventListener('click', function () {
            state.sampleMode = btn.getAttribute('data-mode');
            $$('.sgb-pick', root).forEach(function (b) { b.classList.toggle('on', b === btn); });
            var fl = $('[data-flavors]', root);
            if (fl) fl.hidden = false;
          });
        });
        $$('[data-sku]', root).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var mode = state.sampleMode || btn.getAttribute('data-mode') || 'gift';
            var sku = btn.getAttribute('data-sku');
            state.sampleMode = mode;
            state.sampleSku = sku;
            emit('sgb:sample-choice', { brand: brand, sku: sku, mode: mode });
            maybeCart(btn.getAttribute('data-handle'), sku, mode);
            show('done');
          });
        });
      }
    }

    function flavorBySku(sku) {
      var flavors = (cfg.sample && cfg.sample.flavors) || [];
      for (var i = 0; i < flavors.length; i++) {
        if (flavors[i] && (flavors[i].sku === sku || flavors[i].id === sku)) return flavors[i];
      }
      return null;
    }

    function parseVariantId(raw) {
      if (raw == null || raw === '') return null;
      var s = String(raw);
      var slash = s.lastIndexOf('/');
      if (slash !== -1) s = s.slice(slash + 1);
      var n = parseInt(s, 10);
      return isNaN(n) ? null : n;
    }

    function numericVariantId(flavor) {
      if (!flavor) return null;
      return parseVariantId(flavor.variantId != null ? flavor.variantId : flavor.variant_id);
    }


    function friendMailerUrl() {
      var raw = String((cfg && cfg.friendMailerUrl) || window.SGB_FRIEND_MAILER || '').trim();
      if (!raw) return '';
      if (/\/api\/sample-friend\/send\/?$/.test(raw)) return raw;
      return raw.replace(/\/$/, '') + '/api/sample-friend/send';
    }

    function notifyFriend() {
      if (friend) return;
      if (!state.giftEmail) return;
      var url = friendMailerUrl();
      if (!url) return;
      var payload = {
        friendEmail: state.giftEmail,
        senderName: state.firstName || 'A friend',
        brand: brand
      };
      try {
        var req = fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (req && typeof req.catch === 'function') {
          req.catch(function (err) {
            try { console.warn('[sgb] friend mailer failed', err); } catch (e) {}
          });
        }
      } catch (err) {
        try { console.warn('[sgb] friend mailer failed', err); } catch (e2) {}
      }
    }

    /* Both paths add the $4.99 Single Can. Pal: ONME. Buyer: HLSAMPLE. No $0 SAMP. */
    function cartVariantId(flavor) {
      if (!flavor) return null;
      var retail = parseVariantId(
        flavor.retailVariantId != null ? flavor.retailVariantId : flavor.retail_variant_id
      );
      if (retail) return retail;
      return numericVariantId(flavor);
    }

    function sampleDiscountCode() {
      if (friend) {
        return (cfg.offer && cfg.offer.friend && cfg.offer.friend.discountCode) || 'ONME';
      }
      return (cfg.offer && cfg.offer.buyer && cfg.offer.buyer.discountCode) || 'HLSAMPLE';
    }

    function maybeCart(handle, sku, mode) {
      if (!cfg.liveCart) return Promise.resolve(false);

      var selfSku = state.selfSku || sku;
      var selfF = flavorBySku(selfSku);
      var selfId = cartVariantId(selfF);
      if (!selfId) {
        emit('sgb:cart-error', {
          brand: brand,
          reason: 'missing-variant-id',
          selfSku: selfSku,
          friend: friend
        });
        return Promise.resolve(false);
      }

      var props = {
        _sgb_sample: '1',
        _sgb_mode: 'self',
        _sgb_sku: selfSku
      };
      if (state.firstName) props._sgb_sender_name = state.firstName;
      if (state.giftEmail) props._sgb_friend_email = state.giftEmail;

      var payload = {
        items: [
          {
            id: selfId,
            quantity: 1,
            properties: props
          }
        ]
      };

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) {
          emit('sgb:cart-error', { brand: brand, status: r.status });
          return false;
        }
        var code = sampleDiscountCode();
        emit('sgb:cart-add', { brand: brand, selfSku: selfSku, variantId: selfId, friend: friend, retail: true, friendEmail: !!state.giftEmail, discountCode: code });
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
        } else {
          window.location.href = '/cart';
        }
        return true;
      }).catch(function (err) {
        emit('sgb:cart-error', { brand: brand, error: String(err) });
        return false;
      });
    }

    root._sgbClose = close;
    root._sgbOpen = open;
    root._sgbState = state;
    return { open: open, close: close, show: show };
  }

  function boot() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    var cfg = window.SGB_SAMPLE_OFFER;
    if (!cfg || !cfg.brand) {
      try { console.warn('[sgb] missing window.SGB_SAMPLE_OFFER'); } catch (e) {}
      return;
    }
    if (qs('sgb_debug') === '1') window.SGB_SAMPLE_DEBUG = true;

    /* Always build so Get your can / _sgbOpen works even if auto-open is skipped. */
    var ui = build(root, cfg);
    window.sgbOpenSample = function () { ui.open(); };
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('.hlab, .cz-comic-btn, .ct2-btn, [data-sgb-open]');
      if (!t) return;
      e.preventDefault();
      ui.open();
    }, true);

    var force = qs('sgb_debug') === '1' || qs('sgb_preview') === '1';
    var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    var onHome = path === '/';
    if (!force && shouldSkip(cfg, root)) return;
    if (!force && !onHome) return;

    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 1800;
    if (qs('sgb_friend') === '1' || qs('sgb_debug') === '1') delay = 200;

    waitForAgeGate(cfg, function () {
      setTimeout(function () { ui.open(); }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
